import React, { Component } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TableWaterBalanceRealLoss from './table-water-balance/table-water-balance.component';
import WrapperChartWaterBalance from './wrapper-chart-water-balance/wrapper-chart-water-balance.component';
import WrapperTextNoteChart from './wrapper-chart-water-balance/wrapper-text-note-for-chart/wrapper-text-note-for-chart.component';

import './wrapper-water-balance-table.style.css';

export class WrapperWaterBalanceTable extends Component {
    constructor(props){
        super();
    }

    render() {
        // console.log('this.props.dataNRWByDMA',this.props.dataNRWByDMA);
        return (
            <div className="wrapper-total">
                <h1 className="name-element-search-box">Water balance table</h1>
                <div className="container-tab-table-total">
                    <Tabs defaultActiveKey="IWA" id="uncontrolled-tab-example">
                        <Tab eventKey="IWA" title="IWA water balance">
                            <div className="wrapper-table-total-pipeline">
                                <div className="container-calculator-table">
                                    <TableWaterBalanceRealLoss dataNRWByDMA={this.props.dataNRWByDMA}></TableWaterBalanceRealLoss>
                                </div>
                                <p style={{ marginTop: '10px', marginBottom: '0px' }}>Developing Countries: General description of Real Loss Management Performance Categories for Developing Countries</p>
                            </div>
                        </Tab>
                        <Tab eventKey="ILI" title="ILI range">
                            <div className="wrapper-table-total-pipeline">
                                <WrapperChartWaterBalance dataNRWByDMA={this.props.dataNRWByDMA}></WrapperChartWaterBalance>
                            </div>
                            <WrapperTextNoteChart></WrapperTextNoteChart>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default WrapperWaterBalanceTable
